import 'element-ui/lib/theme-default/index.css'
import 'font-awesome/css/font-awesome.css'
import 'nvd3/build/nv.d3.css'
import 'material-design-icons/iconfont/material-icons.css'

import Vue from 'vue'
import Vuex from 'vuex'
import VueMoment from 'vue-moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vueGettext from 'vue-gettext'
import ElementUI from 'element-ui'
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import Sugar from 'sugar/dist/sugar.js'
import VueClipboard from 'vue-clipboard2'
import VueFileUpload from 'vue-file-upload'
import infiniteScroll from 'vue-infinite-scroll'
import fileBase64 from 'vue-file-base64'
import VueQRCodeComponent from 'vue-qrcode-component'
import App from './App'
import router from './router'
import store from './store'
import * as filters from './filter'
import translations from '../static/language/translation.json'
// require('../mock/index')
// remote script
import '@/components/common/remote-script'

Vue.use(Vuex)
Vue.use(VueMoment)
Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(Sugar)
Vue.use(VueClipboard)
Vue.use(VueFileUpload)
Vue.use(infiniteScroll)
Vue.use(fileBase64)
Vue.component('qr-code', VueQRCodeComponent)

// 设置语言
if (localStorage.getItem('currentLanguage')) {
  if (localStorage.getItem('currentLanguage') === 'en_US') {
    locale.use(en)
  } else {
    locale.use(zh)
  }
} else {
  locale.use(zh)
}

// regist filters
Object.forEach(filters, (key, val) => {
  Vue.filter(key, val)
})
// regist i18n
Vue.use(vueGettext, {
  availableLanguages: {
    zh_CN: '简体中文',
    en_US: 'English'
  },
  defaultLanguage: localStorage.getItem('currentLanguage') || 'zh_CN',
  translations: translations,
  silent: true
})

// regist interceptor for request
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error && error.response) {
    const data = error.response.data
    if (data.code === 'NeedLogin') {
      router.push('/login')
    }
  }
  return Promise.reject(error)
})

// configs for vue
Vue.config.productionTip = false

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

window.rootVue = vm



// WEBPACK FOOTER //
// ./src/console.entry.js